function organizeAssetDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/organize-asset/organize-asset-dialog.html?$$REVISION$$'
  }
}

export { organizeAssetDialog }
